import { isEqual } from "lodash";
import { createDirtyChecker } from "../../gvc/testNewForm/createDirtyChecker";
import { inputToSecret } from "../utils";

const typeToKey: Record<string, string> = {
  "azure-connector": "azureConnector",
  "azure-sdk": "azureSdk",
  "nats-account": "natsAccount",
};

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, inputToSecret, (initItem, currItem) => {
    const dirty: Record<string, boolean> = {};
    if (!isEqual(initItem.description, currItem.description)) dirty.description = true;
    if (!isEqual(initItem.data, currItem.data)) {
      const key = typeToKey[initItem.type] || initItem.type;
      dirty[key] = true;
    }
    if (!isEqual(initItem.tags, currItem.tags)) dirty.tags = true;
    return dirty;
  });
}
